import { render } from "./Noticias.vue?vue&type=template&id=8cd2ad08&scoped=true&ts=true"
import script from "./Noticias.vue?vue&type=script&lang=ts"
export * from "./Noticias.vue?vue&type=script&lang=ts"

import "./Noticias.vue?vue&type=style&index=0&id=8cd2ad08&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd2ad08"]])

export default __exports__